// src/extenders/dynamic-delivery-date.js
var DynamicDeliveryDate = class extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    const container = document.createElement("div");
    container.id = "delivery-date-display";
    container.classList.add("delivery-date-message");
    const style = document.createElement("style");
    style.textContent = `
      .delivery-date-message .delivery-date {
        font-weight: 600;
      }
    `;
    this.shadowRoot.append(style, container);
    this.updateDeliveryMessage();
  }
  updateDeliveryMessage() {
    const container = this.shadowRoot.getElementById("delivery-date-display");
    if (container) {
      const today = /* @__PURE__ */ new Date();
      const startDate = new Date(today);
      const endDate = new Date(today);
      startDate.setDate(today.getDate() + 14);
      endDate.setDate(today.getDate() + 21);
      const options = { day: "numeric", month: "long" };
      const formattedStartDate = startDate.toLocaleDateString("nl-NL", options);
      const formattedEndDate = endDate.toLocaleDateString("nl-NL", options);
      container.innerHTML = `
        <p class="delivery-date-message">
          \u{1F4E6} ${window.dynamicDeliveryDate.expected}
          <br/><span class="delivery-date">${window.dynamicDeliveryDate.between} ${formattedStartDate} ${window.dynamicDeliveryDate.and} ${formattedEndDate}</span>
        </p>
      `;
    }
  }
  connectedCallback() {
    this.updateDeliveryMessage();
  }
};
customElements.define("dynamic-delivery-date", DynamicDeliveryDate);
